(function () {
  if (window.__msdiHdrCollapse) return;
  window.__msdiHdrCollapse = true;
  var root = document.documentElement;
  var compact = false;
  var queued = false;
  var DOWN = 140; /* collapse after scrolling this far */
  var UP = 40;    /* expand again only near the top (hysteresis avoids flicker) */
  function update() {
    queued = false;
    var y = window.pageYOffset || root.scrollTop || 0;
    if (!compact && y > DOWN) {
      compact = true;
      root.classList.add('msdi-hdr-compact');
    } else if (compact && y < UP) {
      compact = false;
      root.classList.remove('msdi-hdr-compact');
    }
  }
  window.addEventListener('scroll', function () {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(update);
  }, { passive: true });
  update();
})();